import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

import {ContentStyled} from '../../styles/components/content.style';

export const Wrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export const MenuWrapperStyled = ContentStyled.extend`
  padding: 0;
  display: flex;
  position: relative;
  max-width: ${p => p.theme.menuPage.menu.maxWidth};
`;

export const MenuWrapperStyledLight = styled(MenuWrapperStyled)`
  ${media.small`
    height: 100vh;
  `};
`;

export const MenuContent = styled.div`
  background-color: ${p => p.theme.menuPage.menu.backgroundColor};
  ${media.small`
    padding-bottom: 14.3rem;
  `};
`;

export const WrapperLight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${media.small`
    width: 100%;
  `};
`;

export const SideRestaurantClosed = styled.aside`
  width: ${p => p.theme.menuPage.basket.width};
  min-width: ${p => p.theme.menuPage.basket.width};
  ${media.small`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./containers/MenuPage/MenuPage.style.js